import PropTypes from 'prop-types';
import { Select } from 'react-materialize';
const SubdivisionSelect = ({ disabled, id, label, subdivisionField, subdivisionList }) => (
  <>
    <Select
      disabled={disabled}
      id={id}
      label={label}
      onChange={subdivisionField.onChange}
      tabIndex={131}
      value={subdivisionField.value || ''}
    >
      <option disabled={disabled} value="">
        Choose
      </option>
      {subdivisionList.map((subdivision, index) => (
        <option key={subdivision.name + '-' + index} value={subdivision.value}>
          {subdivision.label.defaultMessage}
        </option>
      ))}
    </Select>
    {subdivisionField.error ? (
      <div className="field-error" key="error div">
        {subdivisionField.error}
      </div>
    ) : (
      ''
    )}
  </>
);

SubdivisionSelect.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subdivisionField: PropTypes.object.isRequired,
  subdivisionList: PropTypes.array.isRequired,
};

export default SubdivisionSelect;
